import { render, staticRenderFns } from "./AppChips.vue?vue&type=template&id=b63f5652"
import script from "./AppChips.vue?vue&type=script&lang=ts"
export * from "./AppChips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports